export default __webpack_public_path__ + "static/media/03_s.fcf5b1f4.png";